<template>
	<div>
		<div class="d-flex flex-row mb-4">
			<h1>Nueva llamada</h1>
		</div>

		<div class="d-flex flex-row-reverse mb-4">
			<h2> Duración {{humanTime}} </h2>
		</div>

		<div class="content-block">
			<form @submit.prevent="validateBeforeSubmit">
				<b-form-group :state="errors.first('schoolId') ? false : true" :invalid-feedback="errors.first('schoolId')" label="Colegio" label-for="schoolId">
					<b-form-select v-model="schoolSelected" :options="this.schoolsDropdown" :state="errors.first('schoolId') ? false : null" v-validate="'required'" name="schoolId" id="schoolId">
						<template slot="first">
							<option :value="null">Selecciona un colegio</option>
						</template>
					</b-form-select>
				</b-form-group>

				<b-form-group :state="errors.first('reasonId') ? false : true" :invalid-feedback="errors.first('reasonId')" label="Tema" label-for="reasonId">
					<b-form-select :options="this.reasonsDropdown" :state="errors.first('reasonId') ? false : null" v-validate="'required'" v-model="reasonSelected" name="reasonId" id="reasonId">
						<template slot="first">
							<option :value="null">Selecciona un tema</option>
						</template>
					</b-form-select>
				</b-form-group>

				<b-form-group :state="errors.first('callerType') ? false : true" :invalid-feedback="errors.first('callerType')" label="Tipo de cliente" label-for="callerType">
					<b-form-select :options="this.callerTypesDropdown" :state="errors.first('callerType') ? false : null" v-validate="'required'" v-model="callerTypeSelected" name="callerType" id="callerType">
						<template slot="first">
							<option :value="null">Selecciona un tipo de cliente</option>
						</template>
					</b-form-select>
				</b-form-group>

				<b-form-group label="Nombre del cliente" label-for="callerName">
					<b-form-input @keyup.enter.native="validateBeforeSubmit" v-model="callerName" id="callerName" type="text"/>
				</b-form-group>

				<b-form-group :state="errors.first('callerEmail') ? false : true" :invalid-feedback="errors.first('callerEmail')" label="Correo electrónico de contacto" label-for="callerEmail">
					<b-form-input @keyup.enter.native="validateBeforeSubmit" :state="errors.first('callerEmail') ? false : null" v-validate="'email'" v-model="callerEmail" name ="callerEmail" id="callerEmail" type="text"/>
				</b-form-group>

				<b-form-group label="Teléfono de contacto" label-for="callerPhone">
					<b-form-input @keyup.enter.native="validateBeforeSubmit" v-model="callerPhone" id="callerPhone" type="text"/>
				</b-form-group>

				<b-form-group label="Comentarios" label-for="comments">
					<b-form-textarea v-model="comments" id="comments" rows="5" type="text"/>
				</b-form-group>

				<b-button :disabled="submitted" @click="validateBeforeSubmit" variant="primary" class="cursor-pointer">Terminar llamada</b-button>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	timeout: null,
	data () {
		return {
			errorMessage: null,
			submitted: false,
			time: 0,
			counter: 0,
			timer_is_on: 0,
			schoolSelected: null,
			reasonSelected: null,
			callerTypeSelected: null,
			comments: '',
			callerName: '',
			callerEmail: '',
			callerPhone: ''
		};
	},
	created () {
		this.startCount();
	},
	destroyed () {
		this.stopCount();
	},
	computed: {
		call () {
			return {
				createdAt: new Date(),
				callDurationSeconds: this.time,
				schoolId: this.schoolSelected,
				reasonId: this.reasonSelected,
				callerTypeId: this.callerTypeSelected,
				comments: this.comments,
				callerName: this.callerName,
				callerEmail: this.callerEmail,
				callerPhone: this.callerPhone,
				agentId: this.$store.state.session.currentUser.id
			};
		},
		schoolsDropdown () {
			return this.$store.state.dropdowns.schoolsDropdown;
		},
		reasonsDropdown () {
			return this.$store.state.dropdowns.reasonsDropdown;
		},
		callerTypesDropdown () {
			return this.$store.state.dropdowns.callerTypesDropdown;
		},
		humanTime () {
			let hours = Math.floor(this.time / 3600);
			let minutes = Math.floor((this.time % 3600) / 60);
			let seconds = this.time % 60;
			//Anteponiendo un 0 a los minutos si son menos de 10
			minutes = minutes < 10 ? '0' + minutes : minutes;
			//Anteponiendo un 0 a los segundos si son menos de 10
			seconds = seconds < 10 ? '0' + seconds : seconds;
			if (hours == 0) return `${minutes}:${seconds}`;
			else return `${hours}:${minutes}:${seconds}`;
		}
	},
	methods: {
		timedCount: function () {
			this.time = this.counter;
			this.counter = this.counter + 1;
			this.timeout = setTimeout(() => {
				this.timedCount();
			}, 1000);
		},
		startCount: function () {
			if (!this.timer_is_on) {
				this.timer_is_on = 1;
				this.timedCount();
			}
		},
		stopCount: function () {
			clearTimeout(this.timeout);
			this.timer_is_on = 0;
		},
		validateBeforeSubmit: async function ()	{
			try {
				let isTerminated = confirm('¿Terminar llamada?');
				if (!isTerminated) return;
				this.errorMessage = null;
				let validationResult = await this.$validator.validateAll();
				if (validationResult) {
					this.submitted = true;
					this.$store.dispatch('createCall', this.call);
					this.submitted = false;
				}
			} catch (error) {
				this.submitted = false;
				this.errorMessage = error.response.data.message;
			}
		}
	}
};
</script>

<style media="screen">
</style>



// WEBPACK FOOTER //
// src/components/calls/New.vue